import { render, staticRenderFns } from "./PublisherWarning.vue?vue&type=template&id=6d62c658&scoped=true"
import script from "./PublisherWarning.vue?vue&type=script&lang=js"
export * from "./PublisherWarning.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d62c658",
  null
  
)

export default component.exports